// API Models -----------------------------------------------------------------
export interface Program {
  StartTime: Date;
  EndTime: Date;
  ImageUrl: string;
  ThumbnailUrl: string;
  Title: string;
  Description: string;
}

export interface EPG {
  programs: Program[];
}

// UI Models -----------------------------------------------------------------

export interface UIProgram {
  isLive: boolean;
  isWatching: boolean;
  program: Program;
}

export enum UIEPGDirection {
  Initial = 0,
  Right = 1,
  Left = 2,
  Up = 3,
  Down = 4
}
